import { render, staticRenderFns } from "./WorkerInformation.vue?vue&type=template&id=5f08c64d&scoped=true&"
import script from "./WorkerInformation.vue?vue&type=script&lang=js&"
export * from "./WorkerInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f08c64d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f08c64d')) {
      api.createRecord('5f08c64d', component.options)
    } else {
      api.reload('5f08c64d', component.options)
    }
    module.hot.accept("./WorkerInformation.vue?vue&type=template&id=5f08c64d&scoped=true&", function () {
      api.rerender('5f08c64d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/management/vistas/components/WorkerInformation.vue"
export default component.exports